import { QueryParamManager } from '../utils/QueryParamManager';
import { router } from '../utils/router';
export function accountTripCSRsSelectedRoute(tripId) {
    const paramManager = new QueryParamManager(`/account/trip/${tripId}/csrs`, router.currentParams());
    return [paramManager.toString(), undefined, { shallow: false }];
}
export function accountTripCSRsSelectedRouting(tripId) {
    router.push(tripId, accountTripCSRsSelectedRoute);
}
